import { Injectable } from '@angular/core';
import {AppSettings} from '../../proyect.conf';
import {HttpClient} from '@angular/common/http';
import {AutenticacionService} from './autenticacion.service';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {ProductosMediosAsociados} from '../_models/productos-medios-asociados';

@Injectable({
  providedIn: 'root'
})
export class ProductosMediosAsociadosService {
  private rutaServicio = AppSettings.rutServiciosAPL + '/api/productosMediosAsociados/';
  constructor(private httpClient: HttpClient, private autenticacionService: AutenticacionService) { }


  listadoHabilitadoxProducto(idProducto): Observable<ProductosMediosAsociados[]> {
    return this.httpClient.get( this.rutaServicio + 'producto/' + idProducto ).pipe( map( res => res as ProductosMediosAsociados[] ) );
  }


  bulk( regActualizar: ProductosMediosAsociados[] ): Observable<ProductosMediosAsociados[]> {
    regActualizar.map( ( s: ProductosMediosAsociados ) => {
      s.auditoriaUsuario = this.autenticacionService.obtenerIdUsuarioLogueado();
    } );
    return this.httpClient.post( this.rutaServicio + 'bulk', regActualizar ).pipe( map( res => res as ProductosMediosAsociados[] ) );
  }
}
